import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';

// Utils
import { humanizeAccumulatorInfo } from '../../util';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const DetailsList = ({ items }) => {
  if (!items?.length) {
    return null;
  }

  return (
    <ul className={cx('details-wrapper')}>
      {items.map((item) => (
        item.size && (
          <li key={item.unit} className={cx('details-wrapper__item')}>
            <span className={cx('details-wrapper__item-unit')}>
              <Text>
                {humanizeAccumulatorInfo(item.size, item.unit)}
              </Text>
            </span>
          </li>
        )
      ))}
    </ul>
  );
};

DetailsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    size: PropTypes.number,
    unit: PropTypes.string,
  })),
};

export { DetailsList };
